<template>
  <div class="filtering-group-warning">
    {{ $getText('CONTACT_TOO_MUCH_FILTERING_GROUP_RESULTS') }}
  </div>
</template>
<script lang="js">
export default {
  name: 'ContactsFragmentFilteringGroupWarning',
}
</script>
<style lang="scss" scoped>
.filtering-group-warning {
  font-weight: 900;
  padding: 20px;
}
</style>
